import React from "react";
import { Link } from "react-router-dom";

export interface ProductItem {
  id: number | string;
  title: string;
  slug: string;
  price: number | string;
  delPrice: number | string;
  proImg?: string;
  brand?: string;
  stock?: string;
  size?: string;
}

interface Product2Props {
  products: ProductItem[];
  addToCartProduct: (product: ProductItem) => void;
  addToWishListProduct: (product: ProductItem) => void;
}

const Product2: React.FC<Product2Props> = ({
  products,
  addToCartProduct,
  addToWishListProduct,
}) => {
  const ClickHandler = (): void => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <section className="wpo-product-section section-padding">
      <div className="container">
        <div className="wpo-section-title">
          <h2 className="poort-text poort-in-right">Special Products For You</h2>
          <p>
            From intimate gatherings to grand luxury weddings, we bring together
            creativity, organization, and passion to design every detail with
            precision.
          </p>
        </div>

        <div className="wpo-product-wrap">
          <div className="row">
            {products.length > 0 &&
              products.slice(0, 8).map((product) => (
                <div
                  className="col col-lg-3 col-md-6 col-sm-6 col-12"
                  key={product.id}
                >
                  <div className="wpo-product-item">
                    <div className="wpo-product-img">
                      <img
                        src={product.proImg || "/placeholder.jpg"}
                        alt={product.title || "Product"}
                      />
                      <ul>
                        <li>
                          <button
                            type="button"
                            title="Add to Wishlist"
                            onClick={() => addToWishListProduct(product)}
                            aria-label="Add to Wishlist"
                          >
                            <i className="fi flaticon-heart"></i>
                          </button>
                        </li>
                        <li>
                          <button
                            type="button"
                            title="Add to Cart"
                            onClick={() => addToCartProduct(product)}
                            aria-label="Add to Cart"
                          >
                            Add To Cart
                          </button>
                        </li>
                      </ul>
                    </div>

                    <div className="wpo-product-text">
                      <h3>
                        <Link
                          onClick={ClickHandler}
                          to={`/product-single/${product.slug}`}
                        >
                          {product.title}
                        </Link>
                      </h3>
                      <ul>
                        <li>
                          {product.delPrice.toString().includes("$")
                            ? product.delPrice
                            : `$${product.delPrice}`}
                        </li>
                        <li>
                          {product.price.toString().includes("$")
                            ? product.price
                            : `$${product.price}`}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Product2;
